// extracted by mini-css-extract-plugin
export default {"carousel_container":"CardVideoPlayer_carousel_container__y8hBy","section_video_cards":"CardVideoPlayer_section_video_cards__fK8ML","trailer":"CardVideoPlayer_trailer__NcDh8"};